<template>
  <div class="container bg-gray-100 pb-4 pt-5 p-4 w-full">
    <router-link type="button" class="hover:underline block text-left" to="/">
      <svg class="h-8 w-8 fill-current text-blue-900" xmlns="http://www.w3.org/2000/svg"
        viewBox="274.835 394.86 54.965 55.15">
        <defs />
        <path
          d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z" />
      </svg>
    </router-link>
    <loading
      :height="15"
      color="#fff"
      backgroundColor="#494343cc"
      :active="isLoading"
      loader="dots"
      :can-cancel="true"
      :is-full-page="true"
      z-index="9999"
    />
    <p class="w-full text-center text-2xl mb-2">Reporte de ventas digitales</p>
    <p class="w-full text-right text-xl mb-2">Registros {{ number_registered }}</p>
    <!-- <div class=" text-left  lg:w-1/2  lg:p-10 xl:p-10 mt-2 lg:mt-5 flex flex-wrap">
      <div class="w-full">
        <label> Sección: </label>
        <select id="name_section" class="w-full shadow-md appearance-none border rounded text-grey-darker">
          <option :value="''" selected>Seleccionar una sección</option>
          <option v-for="(serie, i) in sections" :key="i" :value="serie.id">{{ serie.section }}</option>
        </select>
        <span v-if="errorSection" class="text-red-600 text-xs">Seleccione una sección</span>
      </div>
    </div> -->
    <div>

    </div>
    <div class="card relative overflow-x-auto">
      <table v-if="showTableDigitalInsurance" class="table-auto">
        <thead class="text-xs">
          <tr>
            <th class="col pt-2">
              <h3 class="text-left text-sm">RFC</h3>
            </th>
            <th class="col">
              <h3 class="text-center text-sm">Nombre completo</h3>
            </th>
            <th class="col">
              <h3 class="text-sm">Prima total</h3>
            </th>
            <th class="col">
              <h3 class="text-sm">Fecha de venta</h3>
            </th>
            <th class="col">
              <h3 class="text-center text-sm">Vendendor</h3>
            </th>
            <th class="col">
              <h3 class="text-sm">Visualizar</h3>
            </th>
            <th class="col">
              <h3 class="text-sm">Sección</h3>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="coverage in listAccidentPersonaldigitals" :key="coverage.id">
            <td class="col">
              <p class="text-left m-2 text-xs">
                {{ coverage.member.rfc }}
              </p>
            </td>
            <td class="col">
              <p class="text-center m-2 text-xs">
                {{ coverage.member.nombre + " " + coverage.member.apellido_paterno + " " + coverage.member.apellido_materno }}
              </p>
            </td>
            <td class="col">
              <p class="text-center m-2 text-xs">
                {{ $filters.toCurrency(coverage.prima_total) }}
              </p>
            </td>
            <td class="col">
              <p class="text-center m-2 text-xs">
                {{ coverage.fecha_de_venta }}
              </p>
            </td>
            <td class="col">
              <p class="text-center m-2 text-xs">
                {{ coverage.seller.nombre_completo }}
              </p>
            </td>
            <td class="col">
              <p class="text-center m-2 text-xs text-blue-700">
                <router-link :to="{ path: '/digital-sale/' + coverage.id}" id="Trust" append><a >Ver registro </a></router-link>
              </p>
            </td>
            <td class="col">
              <p class="text-center m-2 text-xs">
                {{ coverage.member.lm_section.nombre }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import Swal from "sweetalert2";
import Loading from 'vue-loading-overlay';

//import { ref, onMounted } from 'vue';


export default {
  name: "DigitalSalesReport",
  components: {
    Loading
  },
  data() {
    return {
      api_lineamagisterialproducts: process.env.VUE_APP_APILINEAMAGISTERIALPRODUCTS,
      sections: [],
      selectedSection: [],
      showTableDigitalInsurance: true,
      listAccidentPersonaldigitals: [],
      errorSection: false,
      ccAPI: process.env.VUE_APP_CCAPI,
      token_auth: null,
      number_registered: 0,
      isLoading: false,
    }
  },
  async created() {
    this.isLoading = true
    await this.getTokenAuth();
    this.getSections();
    await this.getAcccidentsPersonalDigitals();
    this.isLoading = false
  },
  mounted() {
    //this.getSections();
  },
  methods: {
    getSections() {
      axios
        .get(this.api_lineamagisterialproducts + "/business/get_all", {})
        .then((response) => {
          this.sections = response.data.result;

        });
    },
    async getAcccidentsPersonalDigitals() {
      await axios.get(
        `${this.ccAPI}digital_sale_personal_accidents/index`,
        { params: { status: "PENDIENTE", section_id: "0", token_auth: this.token_auth} }
      )
      .then((data) => {
        this.listAccidentPersonaldigitals = data.data.response.data
        this.number_registered = this.listAccidentPersonaldigitals.length
      })
    },

    async getTokenAuth(){
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      let data = {
        user: {
          email: "aplm@gcabsa.com.mx",
          password: "cabsa2022",
        },
      };

      await axios.post(this.ccAPI + "/fas/login", data, config).then((dataa) => {
        this.token_auth = dataa.data.token_auth;
      });
    },
  }
}
</script>